import React, { Component } from 'react';
import moment from 'moment';



export default class Days extends Component {

  render() {
    const {start_height, pos_x, pos_y, theme_colors} = this.props;

    const text = [...Array(7).keys()].map((day) =>
      (<text className="text-day"
        key={day}
        x="-9"
        y={start_height * (day + 0.5)}
        fill={theme_colors.text}
        fontSize="14px"
        alignmentBaseline="central"
        textAnchor="end"
      >
        {moment().startOf('week').add(day, 'day').format('ddd')}
      </text>)
    );

    return (<g transform={`translate(${pos_x}, ${pos_y})`}>{text}</g>);
  }
}
